import { request } from 'src/utils/requestV2'

export type Config = {
  hash: string
  config: Dictionary<unknown>
}

const configServiceUrl = '/config/api/user'

export const getConfig = async () => {
  return await request.get<Config>(configServiceUrl).then((res) => res.data)
}

export const saveConfig = async (data: Dictionary<unknown>) => {
  return await request
    .post<Config>(configServiceUrl, data)
    .then((res) => res.data)
}

export const clear = async () => {
  await request.delete(configServiceUrl)
}

export const getHash = async () => {
  return await request
    .get<{ hash: string }>(`${configServiceUrl}/hash`)
    .then((res) => res.data)
}
